import { Component } from '@angular/core';

import { LanguageService } from '../../services/language/language.service';

import { ConstantStrings } from '../../constants/constant-strings';


@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {


  markdownFiles:any = ConstantStrings.markdownFiles
  

  constructor(
    public languageService:LanguageService,
  ) { }

  
  openEthicalChannel(){
    const url = ConstantStrings.externalUrl.ethicalChannel;
    window.open(url, '_blank');
  }

  openMarkdownFile(targetFile:string){
    window.open(`/markdown-viewer?file=${targetFile}`, '_self');
  }

  openTransparencyPortal(){
    const url = ConstantStrings.externalUrl.transparencyPortal;
    window.open(url, '_blank');
  }



}
